const styles = (theme) => ({
  sliderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 64,
    paddingLeft: '10%',
    paddingRight: '10%',
    '&.newDesign': {
      paddingTop: 40,
    }
  },
  sliderHelpText: {
    paddingTop: 56,
    width: '80%',
    textAlign: 'center',
    '&.newDesign': {
      paddingTop: theme.spacing(4),
      width: '100%',
      fontFamily: 'Roboto-Bold',
      fontSize: 16,
    }
  },
});

export default styles;